import { render, staticRenderFns } from "./SampleRequestEdit.vue?vue&type=template&id=cfbb47cc&"
import script from "./SampleRequestEdit.vue?vue&type=script&lang=js&"
export * from "./SampleRequestEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports